export default __webpack_public_path__ + "static/media/four.797cac62.svg";